var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 30H26.25C28.32 30 30 28.32 30 26.25V3.75C30 1.68 28.32 0 26.25 0H3.75C1.68 0 0 1.68 0 3.75V26.25C0 28.32 1.68 30 3.75 30ZM22.4625 11.6775C22.4625 16.755 18.5925 22.62 11.52 22.62C9.3525 22.62 7.3275 21.9825 5.6325 20.9025C5.9325 20.94 6.24 20.955 6.5475 20.955C8.3475 20.955 10.005 20.34 11.325 19.305C9.645 19.275 8.22 18.165 7.7325 16.635C7.965 16.68 8.205 16.7025 8.4525 16.7025C8.805 16.7025 9.1425 16.6575 9.465 16.5675C7.71 16.215 6.3825 14.655 6.3825 12.795V12.7425C6.9 13.0275 7.4925 13.2 8.1225 13.2225C7.095 12.5325 6.4125 11.355 6.4125 10.02C6.4125 9.315 6.6 8.655 6.93 8.085C8.8275 10.41 11.6625 11.9475 14.8575 12.105C14.7975 11.82 14.76 11.5275 14.76 11.2275C14.76 9.105 16.485 7.38 18.6075 7.38C19.71 7.38 20.7075 7.845 21.4125 8.595C22.29 8.4225 23.115 8.1075 23.8575 7.665C23.565 8.565 22.9575 9.3225 22.1625 9.795C22.9425 9.6975 23.685 9.495 24.375 9.1875C23.8575 9.96 23.205 10.6425 22.455 11.1825C22.4625 11.3475 22.4625 11.5125 22.4625 11.6775Z",
    fill: "#FDD65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3ef611b085c60ce7b032a1abc9d8fd83.svg";
export { ForwardRef as ReactComponent };